import { render, staticRenderFns } from "./CustomCellItem.vue?vue&type=template&id=d20b565c&scoped=true"
import script from "./CustomCellItem.vue?vue&type=script&lang=js"
export * from "./CustomCellItem.vue?vue&type=script&lang=js"
import style0 from "./CustomCellItem.vue?vue&type=style&index=0&id=d20b565c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20b565c",
  null
  
)

export default component.exports